import { render, staticRenderFns } from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=template&id=2bed8d70&"
import script from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bed8d70')) {
      api.createRecord('2bed8d70', component.options)
    } else {
      api.reload('2bed8d70', component.options)
    }
    module.hot.accept("./BundleCouponCreateAndUpdateFormItems.vue?vue&type=template&id=2bed8d70&", function () {
      api.rerender('2bed8d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BundleCouponCreateAndUpdateFormItems.vue"
export default component.exports